import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { formItem } from '../preview-forms.interface';
import moment from 'moment';

@Component({
    selector: 'app-form-time',
    templateUrl: './form-time.component.html',
    styleUrls: ['./form-time.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormTimeComponent {
  date: any;
  form!: formItem;
  @Input('model') set item(v: formItem) {
    this.form = v;
    if (this.form?.answer_value) this.setValue()
  }

  @Output('valid') valid = new EventEmitter()

  @Output('update') update = new EventEmitter()

  setValue() {
    this.date = moment(this.form.answer_value).format('HH:mm')
  }

  updateValue() {
    this.update.emit(moment(this.date).format())
  }

  updateValiDate(e: any) {
    this.valid.emit(e)
  }
}
